// extracted by css-extract-rspack-plugin
export default {"ReviewSectionsErrorFallbackBanner":"sputnik__ReviewSectionsErrorFallbackBanner__aChOU","reviewSectionsErrorFallbackBanner":"sputnik__ReviewSectionsErrorFallbackBanner__aChOU"};